import React from "react";

type DownloadStatus = "checking" | "downloading" | "ready" | "failed" | null;

interface DownloadActionProps {
  onDownload: () => void;
  status: DownloadStatus;
}

export const DownloadAction: React.FC<DownloadActionProps> = ({
  onDownload,
  status,
}) => {
  return (
    <button
      onClick={onDownload}
      disabled={!!status}
      className="w-full flex items-center justify-between px-3 py-2 rounded-sm bg-gray-800 hover:bg-gray-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {status ? (
        <span className="text-gray-300 flex items-center gap-2">
          {status === "checking" && "Checking..."}
          {status === "downloading" && "Preparing..."}
          {status === "ready" && "Ready"}
          {status === "failed" && "Failed"}
          {(status === "checking" || status === "downloading") && (
            <div className="w-3 h-3 border-2 border-gray-300 border-t-white rounded-full animate-spin" />
          )}
        </span>
      ) : (
        <span className="text-gray-300">Download</span>
      )}
      <kbd className="px-2 py-1 bg-gray-900 rounded-sm text-white text-xs">⌘D</kbd>
    </button>
  );
};

export type { DownloadStatus };
